"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUniqueItems = getUniqueItems;
exports.getNonNullArray = getNonNullArray;
function getUniqueItems(items, getId) {
    const uniqueItems = [];
    const set = new Set();
    items.forEach(item => {
        const id = getId(item);
        if (!set.has(id)) {
            set.add(id);
            uniqueItems.push(item);
        }
    });
    return uniqueItems;
}
/**
 * Filter out null values from list
 *
 * @param value may contain null values
 * @return array without any null values, return empty if nothing found
 */
function getNonNullArray(value) {
    return value != null ? value.flatMap(f => (f != null ? [f] : [])) : [];
}
//# sourceMappingURL=ArrayHelper.js.map